import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=35078e3a&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35078e3a')) {
      api.createRecord('35078e3a', component.options)
    } else {
      api.reload('35078e3a', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=35078e3a&", function () {
      api.rerender('35078e3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/refund_log/Index.vue"
export default component.exports